import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedNumber } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'

import CardsLayout from '../../components/common/cardsLayout/CardsLayout'
import Card from '../../components/common/card/Card'
import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import Icon from '../../components/common/icon/Icon'
import ReportBox from '../../components/common/reportBox/ReportBox'
import Tooltip from '../../components/common/tooltip/Tooltip'
import EmptyState from '../../components/common/emptyState/EmptyState'
import DropDownElement from '../../components/common/dropDownElement/DropDownElement'
import DataRangeSelector from '../../components/common/dataRangeSelector/DataRangeSelector'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import Link from '../../components/common/link/Link'
import AreaChart from '../../components/common/areaChart/AreaChart'
import Personalization from '../../components/common/personalization/Personalization'

import { getEmailMessages, getEmailSendings } from '../../api/beSendApi/BeSendApi'
import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getMessageTotalCounters, getMessageHourCounters, getMessageUrlTotalCounters } from '../../api/statisticsApi/StatisticsApi'
import { getAccountDataRetention } from '../../api/beAccount/BeAccount'
import { getUnsubscriptionCounter } from '../../api/beRecipientApi/BeRecipientApi'
import { chartColor } from '../../services/ChartService'
import { RELEASE_DATE_TIME, MAX_DATE_RANGE_DAYS } from '../../services/Constants'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'
const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'
const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'
const PAGE_STATUS_EMPTY_STATE = 'PAGE_STATUS_EMPTY_STATE'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  loadData: true,
  statDeleted: undefined
}

const intialChart = {
  status: PAGE_STATUS_LOADING,
  data: [],
  period: '10fromLastSend',
  lastPeriodSelected: '10fromLastSend',
  periodDett: '',
  customFrom: null,
  customTo: null,
  lastNotCustomPeriodActivityChart: {},
  lastSendDateCTZ: ''

}

let timeZoneCode = ''
let minFetchDate

// http://localhost:1234/frontend/openclickviewreport/listGuid/AAFA5375-BCF1-4E06-965A-E3A98B626156/idList/1/idNL/90

// http://localhost:1234/frontend/openclickviewreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/55
// https:/d4f0b.smtpnext.com/frontend/openclickviewreport/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/55

const OpenClickViewReport = ({ match, history, location, intl }) => {
  const [pageState, setPageState] = useState(initialPageState)
  const [msgData, setMsgData] = useState({})
  const [data, setData] = useState({})
  const [activityChart, setActivityChart] = useState(intialChart)
  const [listName, setListName] = useState('')

  const showActivityDdlItems = [
    { command: '10fromLastSend', index: 0, className: 'has-separator', label: intl.formatMessage({ id: 'Load.Statistics.10DaysFromLastSend' }) },
    { command: '10', index: 1, label: intl.formatMessage({ id: 'Load.Statistics.LastXDays' }, { X: 10 }) },
    { command: '30', index: 2, label: intl.formatMessage({ id: 'Load.Statistics.LastXDays' }, { X: 30 }) },
    { command: '90', index: 3, className: 'has-separator', label: intl.formatMessage({ id: 'Load.Statistics.LastXDays' }, { X: 90 }) },
    { command: 'custom', index: 4, label: intl.formatMessage({ id: 'Load.Statistics.CustomPeriod' }) }
  ]

  const styleSeriesChart = [
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Open' }),
      fill: chartColor.AcquamarineOneFill,
      stroke: chartColor.AcquamarineOne,
      strokeOpacity: 0.52,
      iconFill: chartColor.AcquamarineOne
    },
    {
      label: intl.formatMessage({ id: 'Load.Common.Clicks' }),
      fill: chartColor.LightblueZeroFill,
      stroke: chartColor.LightblueZero,
      strokeOpacity: 0.69,
      iconFill: chartColor.LightblueZero
    }
  ]

  function convertDateUtctoCTZ (dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)
    // debugger
    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  // on render
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  //  on mount
  useEffect(() => {
    reloadPage()

    // on unmount
    return () => { ReactTooltip.rebuild() }
  }, [])

  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idMessage = parseInt(match.params.idNL)

  useEffect(() => {
    if (pageState.loadData) {
      setPageState((prevState) => ({ ...prevState, loadData: false }))

      const search = {
        IdMessages: [idMessage]
      }
      const types = ['RIT', 'EI', 'AUI', 'AT', 'CU', 'CT', 'ASI']
      const typesUrlTotalCounters = ['UNS', 'SHR', 'S2F']

      Promise.all([
        getEmailMessages(idList, listGuid, search, 1, 1, false),
        getAccountDataRetention(idList, listGuid),
        getListDataById(idList, listGuid)
      ]).then(([emailMessages, retentionDays, listData]) => {
        if (emailMessages.TotalItems > 0) {
          timeZoneCode = listData.TimeZoneCode
          setListName(listData.Name)
          // const retentionOffset = (24 * 60 * 60 * 1000) * ((retentionDays > 365) ? 365 : retentionDays)
          minFetchDate = new Date(RELEASE_DATE_TIME - ((24 * 60 * 60 * 1000) * (retentionDays > 365 ? 365 : 365)))
          setPageState((prevState) => ({ ...prevState, statDeleted: false }))
          Promise.all([
            getEmailSendings(idList, listGuid, search, 1, 1, false),
            getEmailSendings(idList, listGuid, search, 1, 1, true),
            getMessageDetails(idList, listGuid, idMessage, false),
            getMessageTotalCounters(idList, listGuid, idMessage, types, '', ''),
            getMessageUrlTotalCounters(idList, listGuid, idMessage, 0, 1, typesUrlTotalCounters),
            getUnsubscriptionCounter(idList, listGuid, idMessage, 'FBL', '', ''),
            getUnsubscriptionCounter(idList, listGuid, idMessage, 'Any', '', '')

          ]).then(([dateLastSendResp, dateFirstSendResp, msg, totalCounters, urlCounter, abuseReporting, unsubscriptionCounter]) => {
            setMsgData({
              Subject: msg.Subject,
              Notes: msg.Notes ? 'ID ' + idMessage + ' - ' + msg.Notes : 'ID ' + idMessage,
              DateLastSend: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs)) : '-',
              DateFirstSend: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs)) : '-',
              DateLastSendObj: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs) : null,
              DateFirsSendObj: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs) : null
            })

            const delivered = totalCounters.EI - totalCounters.RIT
            const countersData = {
              Recipients: totalCounters.EI,
              Delivered: totalCounters.EI - totalCounters.RIT,
              Bounce: totalCounters.RIT,
              PercDelivered: totalCounters.EI === 0 ? '-' : (totalCounters.EI - totalCounters.RIT) / totalCounters.EI * 100,
              Send: totalCounters.EI,
              Opens: totalCounters.AUI,
              TotalOpens: totalCounters.AT,
              OpensWithoutImage: totalCounters.ASI,
              PercOpens: ((totalCounters.EI - totalCounters.RIT) === 0 || (totalCounters.AUI === 0 && totalCounters.AT === 0)) ? '-' : totalCounters.AUI / (totalCounters.EI - totalCounters.RIT) * 100,
              Clicks: totalCounters.CU,
              TotalClicks: totalCounters.CT,
              PercClicks: ((totalCounters.EI - totalCounters.RIT) === 0 || (totalCounters.CU === 0 && totalCounters.CT === 0)) ? '-' : totalCounters.CU / (totalCounters.EI - totalCounters.RIT) * 100,
              PercClicksOnOpens: (totalCounters.AUI === 0 || (totalCounters.CU === 0 && totalCounters.CT === 0)) ? '-' : totalCounters.CU / totalCounters.AUI * 100,
              AbuseReporting: abuseReporting,
              PercAbuseReporting: (((delivered === 0) || (abuseReporting === 0)) ? '-' : (100 * abuseReporting / (delivered))),
              Unsubscription: unsubscriptionCounter,
              PercUnsubscription: ((totalCounters.EI - totalCounters.RIT) === 0 || unsubscriptionCounter === 0) ? '-' : unsubscriptionCounter / (totalCounters.EI - totalCounters.RIT) * 100
              // ShareOfMsg: totalCounters.SHR + totalCounters.S2F
            }

            const shr = urlCounter.UrlCounters.filter(i => { return i.SpecialLinkType === 6 })
            const s2f = urlCounter.UrlCounters.filter(i => { return i.SpecialLinkType === 5 })
            const shared = shr.length > 0 ? shr[0].Counter : 0
            const send2F = s2f.length > 0 ? s2f[0].Counter : 0
            countersData.ShareOfMsg = shared + send2F

            setData(countersData)

            setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
            activityChartGenerator('10fromLastSend', convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs))
          })
        } else {
          setPageState((prevState) => ({ ...prevState, statDeleted: true, pageStatus: PAGE_STATUS_READY }))
        }
      }).catch(() => {
        setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
      })

      // setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
    }
  }, [pageState.loadData])

  function activityChartGenerator (deltaChart, date) {
    setActivityChart((prevState) => ({ ...prevState, status: PAGE_STATUS_LOADING }))

    if (deltaChart === '10fromLastSend' && !date) {
      setActivityChart((prevState) => ({ ...prevState, status: PAGE_STATUS_ERROR }))
    } else {
      let dateTo = ''
      let dateFrom = ''
      let dateToUtc = ''
      let dateFromUtc = ''

      if (deltaChart === '10fromLastSend') { // date = dateLastSent
        dateFrom = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        dateTo = moment(date).add(+10, 'days').set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toDate()
      } else if (deltaChart === '10' || deltaChart === '30' || deltaChart === '90') {
        dateFrom = moment().add(-parseInt(deltaChart), 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        dateTo = moment().set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toDate()
      } else if (deltaChart === 'custom') {
        // setPeriodActivityChartDett('')
        dateFrom = moment(activityChart.customFrom.toDate()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        dateTo = moment(activityChart.customTo.toDate()).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toDate()
      }
      if (deltaChart !== 'custom') {
        const dateFromFormatted = intl.formatDate(dateFrom, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
        const dateToFormatted = intl.formatDate(dateTo, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })

        setActivityChart((prevState) => ({
          ...prevState,
          customFrom: moment(dateFrom),
          customTo: moment(dateTo),
          periodDett: ' (' + dateFromFormatted + ' - ' + dateToFormatted + ')'
        }))
      }

      dateFromUtc = DateMapper.datetimeSecondToString(DateMapper.fromLocalDate(dateFrom, timeZoneCode))
      dateToUtc = DateMapper.datetimeSecondToString(DateMapper.fromLocalDate(dateTo, timeZoneCode))

      getMessageHourCounters(idList, listGuid, idMessage, ['AUI', 'CU'], dateFromUtc, dateToUtc)
        .then((resp) => {
          if (resp.HourCounters && resp.HourCounters.length > 0) {
            const hourCounters = resp.HourCounters.map((o) => ({ ...o, DateHour: convertDateUtctoCTZ(o.DateHourJs) }))

            const x = addMissingDatePoints(hourCounters, dateFrom, dateTo)

            const data = x.map(({ DateHour, TotalCounters: { AUI, CU } }) => [DateHour, AUI, CU])

            setActivityChart((prevState) => ({ ...prevState, status: PAGE_STATUS_READY, data: data }))
          } else {
            setActivityChart((prevState) => ({ ...prevState, status: PAGE_STATUS_EMPTY_STATE }))
          }
        })
        .catch(() => {
          setActivityChart((prevState) => ({ ...prevState, status: PAGE_STATUS_ERROR }))
        })
    }
  }

  function addMissingDatePoints (data, dateFrom, dateTo) {
    return getHoursArray(new Date(dateFrom), new Date(dateTo))
      .map(date => {
        const item = data.find(item => date.getTime() === item.DateHour.getTime())
        return item !== undefined
          ? item
          : { DateHour: date, TotalCounters: { AUI: 0, CU: 0 } }
      })
  }

  function getHoursArray (start, end) { // fixme: improve this
    const arr = []
    const dt = start
    do {
      dt.setMinutes(0)
      dt.setSeconds(0)
      dt.setMilliseconds(0)
      arr.push(new Date(dt))
      dt.setHours(dt.getHours() + 1)
    } while (dt <= (Date.now() < end.getTime() ? new Date() : end))
    return arr
  }

  const boxOpensProps = {
    className: 'test-OpenCLickReportPubb-boxOpens',
    title: (data.PercOpens !== '-') ? (<FormattedNumber value={data.PercOpens / 100 || 0} maximumFractionDigits={2} style='percent' />) : '-%',
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercOpens' }),
    showGauge: true,
    gaugeValue: data.PercOpens,
    gaugeColor: chartColor.AcquamarineOne,
    items: [{
      label: intl.formatMessage({ id: 'Load.MailupCommon.Open' }),
      value: intl.formatNumber(data.Opens)
    }, {
      label: (<><Icon family='sli' icon='next-1' className='frontend-p-right-xs-thin' />{intl.formatMessage({ id: 'Load.Statistics.OpeningsWithoutImages' })}</>),
      value: intl.formatNumber(data.OpensWithoutImage),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.OpeningsWithoutImagesTooltip' })
    }, {
      label: intl.formatMessage({ id: 'Load.Common.TotalOpens' }),
      value: intl.formatNumber(data.TotalOpens)
    }]

  }

  const boxClicksProps = {
    className: 'test-OpenCLickReportPubb-boxClicks',
    title: (data.PercClicks !== '-') ? (<FormattedNumber value={data.PercClicks / 100 || 0} maximumFractionDigits={2} style='percent' />) : '-%',
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercClicks' }),
    showGauge: true,
    gaugeValue: data.PercClicks,
    gaugeColor: chartColor.LightblueZero,
    items: [{
      label: intl.formatMessage({ id: 'Load.Common.Clicks' }),
      value: intl.formatNumber(data.Clicks)
    }, {
      label: intl.formatMessage({ id: 'Load.Common.TotalClicks' }),
      value: intl.formatNumber(data.TotalClicks)
    }, {
      label: intl.formatMessage({ id: 'Load.Statistics.PercClickOnOpen' }),
      value: (data.PercClicksOnOpens !== '-') ? (<FormattedNumber value={data.PercClicksOnOpens / 100 || 0} maximumFractionDigits={2} style='percent' />) : (<span className='frontend-text-nowrap'>-</span>)
    }]

  }

  const boxUnsubsProps = {
    className: 'test-OpenCLickReportPubb-boxUnsubs',
    title: (data.PercUnsubscription !== '-') ? (<FormattedNumber value={data.PercUnsubscription / 100 || 0} maximumFractionDigits={2} style='percent' />) : (<span className='frontend-text-nowrap'>-%</span>),
    subtitle: intl.formatMessage({ id: 'Load.Statistics.PercUnsub' }),
    items: [{
      label: intl.formatMessage({ id: 'Load.Common.Unsubscriptions' }),
      value: intl.formatNumber(data.Unsubscription),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.UnsubscriptionTooltip' })

    }, {
      label: intl.formatMessage({ id: 'Load.Statistics.AbuseReporting' }),
      value: intl.formatNumber(data.AbuseReporting),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.AbuseReportingTooltip' })
    }, {
      label: intl.formatMessage({ id: 'Load.Statistics.PercAbuseReporting' }),
      value: (data.PercAbuseReporting !== '-') ? (<FormattedNumber value={data.PercAbuseReporting / 100 || 0} maximumFractionDigits={2} style='percent' />) : (<span className='frontend-text-nowrap'>-</span>),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.TooltipAbusi' })
    }, {
      label: intl.formatMessage({ id: 'Load.Statistics.SharingsTotal' }),
      value: intl.formatNumber(data.ShareOfMsg),
      tooltip: intl.formatMessage({ id: 'Load.Statistics.SharingsTooltip' })
    }]

  }

  const propStatDelted = {
    title: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsTitle' }),
    description: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsDescription' })
  }

  const cardProps = {
    className: 'items-per-row-3'
  }

  const propShowActivityDdl = {
    items: showActivityDdlItems,
    selectedIndex: showActivityDdlItems.filter((o) => o.command === activityChart.period)[0].index,
    callback: periodActivityChange,
    className: 'test-OpenCLickReportPubb-ActivityDdl'
  }

  const propShowActivityDataRangeSelector = {
    dateFrom: activityChart.customFrom,
    dateTo: activityChart.customTo,
    minDateFrom: moment.max(moment(minFetchDate), moment(activityChart.customTo).add(-MAX_DATE_RANGE_DAYS, 'days')).toDate(),
    maxDateFrom: activityChart.customTo,
    minDateTo: activityChart.customFrom,
    maxDateTo: moment.min(moment(Date.now()), moment(activityChart.customFrom).add(MAX_DATE_RANGE_DAYS, 'days')).toDate(),
    applyCallback: onClickShowActivityApply,
    cancelCallback: onCliCkShowActivityCustomCancel,
    onChangeDateFrom: handleDatePickerShowActivityFrom,
    onChangeDateTo: handleDatePickerShowActivityTo,
    className: 'test-OpenCLickReportPubb-ActivityDataRangeSelector'
  }

  const propsLoadChartActivityData = {
    height: '335px'
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  function reloadPage () {
    setPageState((prevState) => ({ ...initialPageState, pageStatus: PAGE_STATUS_LOADING }))
  }

  function periodActivityChange (index, command) {
    if (command !== 'custom') {
      setActivityChart((prevState) => ({ ...prevState, period: command, lastPeriodSelected: command }))
      activityChartGenerator(command, msgData.DateLastSendObj)
    } else {
      setActivityChart((prevState) => ({ ...prevState, period: 'custom' }))
    }
  }

  function onClickShowActivityApply () {
    activityChartGenerator('custom')
  }

  function onCliCkShowActivityCustomCancel () {
    setActivityChart((prevState) => ({ ...prevState, period: prevState.lastPeriodSelected }))
    activityChartGenerator(activityChart.lastPeriodSelected, msgData.DateLastSendObj)
  }

  function handleDatePickerShowActivityFrom (date) {
    setActivityChart((prevState) => ({ ...prevState, customFrom: date }))
  }

  function handleDatePickerShowActivityTo (date) {
    setActivityChart((prevState) => ({ ...prevState, customTo: date }))
  }

  return (
    <div className='frontend-wrapper-xl'>

      {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
        <LoadingSpinner />}

      {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
        <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

      {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
        <MessageFeedback kind='error'>
          {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
          <a className='frontend-p-left-xs-thin test-OpenCLickReportPubb-reloadPage' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
        </MessageFeedback>}

      {pageState.statDeleted === true
        ? <>
          <Personalization {...personalizationProps} />
          <EmptyState {...propStatDelted} />
          </>
        : <>
          {(pageState.pageStatus === PAGE_STATUS_READY) && <>
            <Personalization {...personalizationProps} />
            <Tooltip />
            <div className='frontend-row frontend-row_reset row-flex'>
              <h1><b>{intl.formatMessage({ id: 'Load.OpenClickReportFrontend.Title' })}</b></h1>
            </div>

            <div className='frontend-row frontend-row_reset'>
              <div className='col-xs-8 frontend-p-left-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-MsgDett'>
                  <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.MsgDett' })}</b></h3>
                  <p className='frontend-m-bottom-xx-sm'><strong>{msgData.Subject}</strong></p>
                  <p className='frontend-m-bottom-x-sm'>{msgData.Notes}</p>
                  <p className='frontend-m-bottom-x-sm'>
                    <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                    <span>{idList} - {listName}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.FirstSend' })}:</b>&nbsp;
                    <span>{msgData.DateFirstSend} {timeZoneCode.split(':')[0]}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.LastSend' })}:</b>&nbsp;
                    <span>{msgData.DateLastSend} {timeZoneCode.split(':')[0]}</span>
                  </p>

                </div>
              </div>
              <div className='col-xs-4 frontend-p-right-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-Recipients'>
                  <h2><b>{intl.formatNumber(data.Recipients)}</b></h2>
                  <p className='frontend-text-uppercase frontend-note'>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</p>
                </div>

              </div>
            </div>

            <div className='frontend-row'>
              <CardsLayout>
                <Card {...cardProps}><ReportBox {...boxOpensProps} /></Card>
                <Card {...cardProps}><ReportBox {...boxClicksProps} /></Card>
                <Card {...cardProps}><ReportBox {...boxUnsubsProps} /></Card>
              </CardsLayout>
            </div>

            <div className='frontend-row  '>

              <div className='frontend-box frontend-m-bottom-0'>
                <div className='row-flex m-bottom-0'>
                  <h2 className='frontend-m-right-xx-sm '>{intl.formatMessage({ id: 'Load.Statistics.ShowActivity' })}</h2>
                  {/* <DatePickerContainer {...propDateFrom} /> */}
                  {activityChart.period !== 'custom'
                    ? <div className='col-flex-6'>
                      <DropDownElement {...propShowActivityDdl}>

                        <div className='similar-chosen'>{showActivityDdlItems.filter(o => o.command === activityChart.period)[0].label}<span className='text-light'>{activityChart.periodDett}</span></div>
                      </DropDownElement>
                    </div>
                    : <DataRangeSelector className='m-left' {...propShowActivityDataRangeSelector} />}

                </div>
                <div className='frontend-row frontend-m-top-sm'>
                  {activityChart.status === PAGE_STATUS_LOADING && <SingleLoader {...propsLoadChartActivityData} />}
                  {activityChart.status === PAGE_STATUS_ERROR && (
                    <div className='frontend-text-center frontend-m-top-sm'>
                      <Icon family='fa' icon='exclamation-triangle' className='text-light' />
                      <i className='text-light frontend-p-right-thin frontend-p-left-thin'>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</i>
                      <i><Link className='frontend-link-secondary test-ActivityReportPubb-reloadPage' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.Common.RealoadPage' })}</Link></i>
                    </div>
                  )}
                  {activityChart.status === PAGE_STATUS_EMPTY_STATE && (
                    <p className='frontend-text-center frontend-m-top-sm'>
                      <em>
                        {intl.formatMessage({ id: 'Load.Statistics.EmptyStateMessageActivityReportChart' })}
                      </em>
                    </p>
                  )}
                  {(activityChart.status === PAGE_STATUS_READY && activityChart.data.length > 0) && (
                    <div className='anychart test-OpenCLickReportPubb-AreaChart'>
                      <AreaChart style={{ height: '394px' }} data={activityChart.data} styleSeriesChart={styleSeriesChart} ctz={timeZoneCode.split(':')[0]} />
                    </div>
                  )}
                </div>
              </div>
            </div>

                                                           </>}
        </>}

    </div>
  )
}

export default injectIntl(withRouter(OpenClickViewReport))
